/**
 * What a campaign is CALLED, and whether a new one would share that name (A13 — Lee, 28 Sep 2026).
 *
 * Mirror of functions/utils/campaignTitles.js for the create form, which checks as you type;
 * the server's registerCampaign is the gate. See that file for why. Both test files share
 * vectors — change them together.
 */

// The same two lists as functions/utils/hiddenCampaigns.js: never names anyone sees.
const isHidden = (id) => {
  const s = String(id || "");
  return s.startsWith("_suite-") || s === "hsstatic" || s === "scriptloader";
};

/** The title Redirects shows: the display name, or the id after its first hyphen. */
export function campaignTitle(campaign) {
  const c = campaign || {};
  if (c.displayName && String(c.displayName).trim()) return String(c.displayName).trim();
  const id = String(c.campaignId || "");
  const parts = id.split("-");
  if (parts.length < 2) return id;
  const rest = parts.slice(1).join("-");
  try {
    return decodeURIComponent(rest);
  } catch {
    return rest;
  }
}

/** Two titles are one name when they differ only in case, spaces, hyphens or underscores. */
export function titleKey(name) {
  return String(name || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** The existing campaign already called `title`, or null. */
export function findTitleClash(title, campaigns, exceptId) {
  const key = titleKey(title);
  if (!key) return null;
  return (
    (campaigns || []).find(
      (c) =>
        c &&
        c.campaignId !== exceptId &&
        !isHidden(c.campaignId) &&
        titleKey(campaignTitle(c)) === key
    ) || null
  );
}

/**
 * Labels for a campaign picker: the title, plus the id's prefix wherever two campaigns
 * still share a title (older campaigns created by visits, e.g. two HubSpot campaigns
 * both ending "-pos"), so the person choosing can tell them apart.
 */
export function pickerLabels(campaigns) {
  const counts = {};
  (campaigns || []).forEach((c) => {
    const k = titleKey(campaignTitle(c));
    counts[k] = (counts[k] || 0) + 1;
  });
  const labels = {};
  (campaigns || []).forEach((c) => {
    const title = campaignTitle(c);
    labels[c.campaignId] =
      counts[titleKey(title)] > 1 ? `${title} (${String(c.campaignId).split("-")[0]})` : title;
  });
  return labels;
}
